import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SpeechaceService } from './speechace.service';

@Component({
  selector: 'lp2-speechace-modal',
  templateUrl: './speechace-modal.component.html',
  styleUrls: ['./speechace-modal.component.scss'],
})
export class SpeechaceModalComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() activityId: number;
  @Input() courseId: number;
  @Input() isComplete: boolean = false;

  hostUrl: string;
  url: SafeResourceUrl;
  sessionStartTime = Math.floor(new Date().getTime() / 1000.0);

  constructor(
    private readonly speechaceService: SpeechaceService,
    public activeModal: NgbActiveModal,
    private readonly sanitizer: DomSanitizer
  ) {
    this.handleSpeechaceEvents = this.handleSpeechaceEvents.bind(this);
  }

  ngOnInit() {
    this.fetchToken();
    window.addEventListener('message', this.handleSpeechaceEvents, false);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleSpeechaceEvents, false);
  }

  setUrl(token: string) {
    this.hostUrl = this.speechaceService.getHostUrl();
    const url = `${this.hostUrl}/embed/ui/${this.activityId}/?speechace_token=${token}`;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  handleSpeechaceEvents(event) {
    if (!this.hostUrl || event.origin !== this.hostUrl) {
      return;
    }

    if (event.data === 'speechaceActivityComplete') {
      this.closeActivity();
    } else if (event.data === 'speechaceActivityLoadInvalidTokenError') {
      console.error('Speechace: invalid token');
      this.fetchToken(true);
    }
  }

  fetchToken(forceFetch = false) {
    return this.speechaceService.getToken(forceFetch).subscribe(token => {
      this.setUrl(token);
    });
  }

  saveActivity() {
    if (!this.courseId || !this.activityId) {
      return;
    }
  
    this.speechaceService.reportProgressForCourse(this.courseId, this.activityId, this.sessionStartTime, this.isComplete).subscribe();
  }

  closeActivity() {
    this.saveActivity();
    this.activeModal.close();
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/speechace-modal/speechace-modal.component.ts